import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
} from "@mui/material";
import { callAPI } from "../../../../../App/Helpers/callApi";
import Signifier from "../../../../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../../../App/State/Slices/SelectedCareersClientSlice";
import DropdownComponent from "../../../../../App/Components/Dropdown/DropdownComponent";
import {
  editFeaturedAdResults,
  getFeaturedAdResults,
} from "./FeaturedAdResultsService";
import { selectUserPermissionsValue } from "../../../../../App/State/Slices/UserPermissionsSlice";
import { CheckRoleForClient } from "../../../../../App/Helpers/PermissionsChecks";
import { Roles } from "../../../../../App/Enums/Roles";

function FeaturedAdResultsPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "50%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "100%",
    },
    error: {
      color: theme.palette.error.main,
    },
    copy: {
      color: theme.palette.primary.copy,
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const rolesObject = useSelector(selectUserPermissionsValue);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);

  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");

  const [include, setInclude] = useState(false);

  function getData() {
    getFeaturedAdResults(selectCareersClient.id).then((response) => {
      setTemplates(response.templates);
      setInclude(response.configuration?.hasFeaturedResults);
    });
  }

  function saveMapSearch() {
    let data = {
      ClientId: selectCareersClient.id,
      templateId: selectedTemplate?.id,
      configuration: {
        ClientId: selectCareersClient.id,
        HasFeaturedResults: include,
      },
    };
    callAPI(
      editFeaturedAdResults(data),
      "Featured Ad Results Saved",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getData();
    });
  }

  useEffect(() => {
    setTemplates([]);
    setInclude(false);
    if (selectCareersClient !== null) {
      getData();
    }
  }, [selectCareersClient]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className={classes.root}>
        <Grid className={classes.cardContainer}>
          <Card className={classes.card}>
            <CardContent>
              <Grid container spacing={1}>
                {CheckRoleForClient(
                  rolesObject,
                  selectCareersClient.id?.toUpperCase(),
                  Roles.SuperAdmin
                ) ? (
                  <Grid xs={12} sm={12} item>
                    <DropdownComponent
                      emptyRow
                      currValue={selectedTemplate}
                      items={templates}
                      property="name"
                      title="Assign To Template"
                      handleChange={(value) => setSelectedTemplate(value)}
                    />
                  </Grid>
                ) : null}
                <Grid xs={12} sm={12} item>
                  <FormControlLabel
                    className={classes.copy}
                    style={{ marginTop: "10px" }}
                    control={
                      <Checkbox
                        color="primary"
                        checked={include}
                        onChange={() => setInclude(!include)}
                      />
                    }
                    label="Include Feature Job in Search Results"
                  />
                </Grid>
                <Grid item xs={12} sm={12} container justifyContent="flex-end">
                  <Button
                    style={{ marginTop: "20px", marginRight: "8px" }}
                    className={classes.sensitiveButton}
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={() => saveMapSearch()}
                  >
                    Save Information
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </div>
    </>
  );
}

export default FeaturedAdResultsPage;
